export const environment = {
  production: false,
  //websiteApiEndpoint: "https://in7uonfysh.execute-api.eu-central-1.amazonaws.com/Prod/"   //DEV
  websiteApiEndpoint: "https://08pbkay9g8.execute-api.eu-central-1.amazonaws.com/Prod/"     //PROD
};